/*eslint-disable*/
import api from '../'

class MemoryGameApi {
    static getGroups (locale) {
        return api.axios.get('/memory/groups', {params: { locale }}).then(response => response.data);
    }

    static getItemsByRequest (params) {
        return api.axios.post('/memory/items', params).then(response => response.data.items);
    }

    static getImages (amount) {
        return api.axios.get('/memory/images', {params: {amount}}).then(response => response.data);
    }
}

export default MemoryGameApi;
